import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { adminChangePartnerApprovalStatus, approveOrRejectRestaurantDocApi, editRestaurantApi, restaurantById, savePartnerBankDetailsApi, updatePartnerProfileApi, updateRestaurantDetails, updateRestaurantDetailsApi, updateRestaurantDocApi, uploadFileApi } from '../../../utils/ApiEndpointFunctions';
import Spinwheel from '../../common/Spinwheel';
import { capitalizeWords, dateFormat } from '../../../utils/HelperFuncitons';
import { S3_URL } from '../../../utils/BaseUrl';
import ConfirmationModal from '../../common/ConfirmationModal';
import PdfSvgIcon from '../../common/PdfSvgIcon';
import ImageViewModal from '../../common/Modal/ImageViewModal';
import toast from 'react-hot-toast';
import CommonTable from '../../common/Table/CommonTable';
import { useFormik } from 'formik';
import { bankDetailsInitialValue, bankDetailsValidationSchema, documentInitialValues, documentValidationSchemas, profileDetailsInitialValue, profileValidationSchema, rateRestaurantInitialValues, rateRestaurantValidationSchema, restaurantInitialValue, restaurantValidationSchema } from '../../common/Validation';
import moment from 'moment';
import { useAdminContext } from '../../../context/adminContext';
import RestaurantMenu from './RestaurantMenu';
import PartnerReviewTable from '../../common/PartnerReviewTable';
import AddOrUpdateDetails from '../../common/Modal/AddOrUpdateDetails';
import { daysOptions } from '../../../utils/constant';

const RestaurentDetails = (props) => {
  const params = useParams();
  const [id, setId] = useState(params?.id)
  const [profileDetails, setProfiledetails] = useState({});
  const [vehicleDetails, setVehicleDetails] = useState([]);
  const [restaurantDetails, setRestaurantDetails] = useState({});
  const [restaurantDocument, setRestaurantDocument] = useState({});
  const [selectDocument, setSelectDocument] = useState({ status: "", keyName: "", validDate: "", restaurantId: "" });
  const [bankDetails, setBankDetails] = useState([]);
  const [rateLoader, setRateLoader] = useState(false);
  const [loader, setLoader] = useState(true);
  const [activeTab, setActiveTab] = useState('driver');
  const [confirmStatus, setConfirmStatus] = useState({ status: "", userId: "", role: "restaurant" });
  const [selectedImg, setSelectedImg] = useState("")
  const { adminDetail } = useAdminContext();
  const confirmationModalId2 = "confirmationModal2"
  const [detailsType, setDetailsType] = useState({ type: "", loading: false })
  const driverBankModal2 = "driverBankModal2"
  const [fileUpload, setFileUpload] = useState([])
  const [selectedDocument, setSelectedDocument] = useState({ id: null, type: null, loading: false })



  const fetchDriverDetails = async () => {
    try {
      const res = await restaurantById(id);
      if (res.status === 200) {
        const { vehicles, details } = res.data.data;
        const { id, role, phone, referralCode, restaurant, restaurantDocument, bankDetails, partnerUserDetails } = details
        setRestaurantDocument(restaurantDocument)
        setProfiledetails({ id, phone, referralCode, role, ...partnerUserDetails[0], vendorStatus: restaurant.status });
        setVehicleDetails(vehicles);
        setRestaurantDetails(restaurant)
        setBankDetails(bankDetails)
        rateFormik.setValues({ id: id, deliveryFee: restaurant.deliveryFee, tax: restaurant.tax, discountOnOff: restaurant.discountOnOff, discount: restaurant.discount });

      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  const handleChangeStatus = async () => {
    try {
      setLoader(true)
      await adminChangePartnerApprovalStatus(confirmStatus)
      fetchDriverDetails();
      document.getElementById('confirmationModal').click()
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something Went Wrong")
      setLoader(false)
    }
  }

  const openModal = () => {
    document.getElementById('confirmationModal2Btn').click()
  }



  useEffect(() => {
    if (id) {
      fetchDriverDetails();
    }
  }, [id]);

  const toggleTab = (tab) => {
    setActiveTab(tab);
  };


  const genderOptions = [
    { label: "Male", value: "male" },
    { label: "Female", value: "female" },
    { label: "Other", value: "other" },

  ]

  async function handleFileUpload(name, e, formik) {
    try {
      const file = e.target.files[0];
      if (file) {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("type", "documents")
        setFileUpload([...fileUpload, name])
        const res = await uploadFileApi(formData)
        formik.setFieldTouched(name, true)
        if (res.status === 200 && res.data?.status === 1) {
          formik.setFieldValue(name, res.data?.data);
          toast.success("File uploaded");
        }
      }
    } catch (error) {
      formik.setFieldTouched(`image`, true)
      console.log(error)
      if (error?.response === undefined) {
        toast.error("File size is too large")
      }
    }
    setFileUpload([...fileUpload?.filter(ele => ele != name)])
  }

  const handleChangeDocumentStatus = async () => {
    const promise = approveOrRejectRestaurantDocApi({ userId: id, keyName: selectDocument.keyName, status: selectDocument.status, restaurantId: selectDocument.restaurantId });
    toast.promise(
      promise,
      {
        loading: 'Updating document status...',
        success: (res) => {
          if (res.status === 200) {
            profileDetails.vendorStatus = res.data.restaurantStatus ? res.data.restaurantStatus : profileDetails.vendorStatus
            setRestaurantDocument({ ...restaurantDocument, [selectDocument.keyName]: res.data.docStatus })
            return res.data.message || 'Success';
          }
        },
        error: (err) => {
          return err.message || 'Something Went Wrong'
        }
      }
    )
  };

  const DocumentDisplay = ({ title, document, setSelectedImg, status, keyName, validUpto, number, restaurantId }) => {

    if (!document) {
      return (
        <tr>
          <td>{title}</td>
          <td className='text-center'>{`${title} not available`}</td>
        </tr>
      );
    }

    const isPdf = document ? document.split(".").slice(-1)[0] === "pdf" : "";

    return (
      <tr>
        <td>{title}</td>
        <td>{number}</td>
        <td className='text-center'>
          {isPdf ? (
            <Link to={`${S3_URL}/${document}`} className="text-primary">
              <PdfSvgIcon width="100" height="100" />
            </Link>
          ) : (
            <img
              src={`${S3_URL}/${document}`}
              alt={title}
              data-bs-toggle="modal"
              data-bs-target={`#imageViewModal`}
              style={{ cursor: 'pointer', maxWidth: '100%', maxHeight: '100px', borderRadius: "8%" }}
              onClick={() => setSelectedImg(`${S3_URL}/${document}`)}
            />
          )}
        </td>
        <td className='text-center'>{validUpto ? dateFormat(validUpto) : ""}</td>
        <td className='text-center'>{capitalizeWords(status) || "-"}</td>
        {status !== "pending" && <td className='text-center'>
          <div className="dropdown">
            <button
              className=" border-0 bg-white"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-three-dots-vertical"
                viewBox="0 0 16 16"
              >
                <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
              </svg>
            </button>
            <ul
              className="dropdown-menu"
              style={{ zIndex: "1000" }}
            >
              {(status === "rejected" || status === "submitted") && <li
                onClick={() => {

                  setSelectDocument({ status: 'approved', keyName: keyName, validDate: validUpto, restaurantId: restaurantId })
                  openModal()
                }}
              >
                <a className="dropdown-item" href="#">
                  Approve
                </a>
              </li>}

              {(status === "approved" || status === "submitted") && <li
                onClick={() => {
                  setSelectDocument({ status: 'rejected', keyName: keyName, validDate: validUpto, restaurantId: restaurantId })
                  openModal()
                }}
              >
                <a className="dropdown-item" href="#">
                  Reject
                </a>
              </li>}

              <li data-bs-toggle="modal" data-bs-target={`#${driverBankModal2}`} onClick={() => {
                setSelectedDocument({ ...selectedDocument, type: title });

                restaurantDetailsFormik?.setValues({
                  ...restaurantDocument,
                  name: {
                    label: restaurantDocument?.name,
                    value: restaurantDocument?.name,
                  },
                });
                setActiveTab("document")
              }}>
                <a className="dropdown-item" href="#">
                  Edit
                </a>
              </li>
            </ul>
          </div>
        </td>}
      </tr>
    );
  };

  const bankDetailsHeaderData = [
    { name: "Account Holder Name", className: "list-sort text-muted", key: "name" },
    { name: "Bank Name", className: "list-sort text-muted", key: "bankName" },
    { name: "IFSC", className: "list-sort text-muted", key: "Ifsc" },
    { name: "Account Number", className: "list-sort text-muted", key: "accountNo" },
    { name: "Account Type", className: "list-sort text-muted", key: "accountType" },
    { name: <div className='d-flex gap-2 justify-content-center align-items-center'><div>Action</div><div>{!bankDetails?.length && <button className='btn btn-primary' data-bs-toggle="modal" data-bs-target={`#driverBankModal2`}>Add</button>}</div></div>, className: "col-1", key: "action" },
  ]

  const bankDetailsTableData = bankDetails?.map((bnk, index) => ({
    name: profileDetails.name || "",
    bankName: bnk.bankName || "",
    Ifsc: bnk.Ifsc || "",
    accountNo: bnk.accountNo || "",
    accountType: bnk.accountType || "",
    action: (
      <div className="dropdown">
        <button
          className=" border-0 bg-white"
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-three-dots-vertical"
            viewBox="0 0 16 16">
            <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
          </svg>
        </button>
        <ul
          className="dropdown-menu"
          style={{ zIndex: "1000" }}>
          <li
            data-bs-toggle="modal"
            data-bs-target={`#driverBankModal2`}
            onClick={() => {
              restaurantDetailsFormik?.setValues({
                ...bnk,
                name: {
                  label: restaurantDetails?.name,
                  value: restaurantDetails?.name,
                },
              });
              setActiveTab("bankDetails");
            }}
          >
            <a className="dropdown-item" href="#">
              Edit
            </a>
          </li>
        </ul>
      </div>
    ),
  }))

  const profileData = [
    { name: "Email", data: profileDetails.email, },
    { name: "Phone", data: profileDetails.phone, },
    { name: "Alternate Phone", data: profileDetails.alternateMobile, },
    { name: "NIN", data: profileDetails.NIN, },
    { name: "Status", data: capitalizeWords(profileDetails.vendorStatus), },
    { name: "Role", data: profileDetails.role?.map(el => capitalizeWords(el))?.join(", "), },
    { name: "Gender", data: profileDetails.gender, },
    { name: "City", data: profileDetails.city, },
    { name: "State", data: profileDetails.state, },
    { name: "Country", data: profileDetails.country, },
    { name: "Zip Code", data: profileDetails.zip, },
    { name: "Address", data: <div>{profileDetails.permanentAddress && `${profileDetails.permanentAddress}, `}{profileDetails.state && `${profileDetails.state}, `}{profileDetails.city && `${profileDetails.city}, `}{profileDetails.zip && `${profileDetails.zip}`}</div>, },
    { name: "Referral Code", data: profileDetails.referralCode, },
  ]

const dayOrder = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
];

const orderedDays = restaurantDetails?.days
  ?.sort((a, b) => dayOrder.indexOf(a) - dayOrder.indexOf(b));

const daysString = orderedDays?.join(", ");

  const restaurant = [
    { name: "Address", data: restaurantDetails?.address },
    { name: "Opening Time", data: moment(restaurantDetails?.openingTime).format('h:mm A') },
    { name: "Closing Time", data: moment(restaurantDetails?.closingTime).format('h:mm A') },
    { name: "Total Earnings", data: restaurantDetails?.totalEarnings },
    { name: "Contact No", data: restaurantDetails?.contactNo },
    { name: "Days", data: daysString },
    { name: "Delivery Restaurant Timing Type", data: restaurantDetails?.deliveryRestaurantTimingType ? "Delivery timing are different from restaurant timings" : "Delivery and restaurant timings are same" },
    { name: "Establishment Type", data: restaurantDetails?.establishmentType },
    { name: "Online", data: restaurantDetails?.isOnline ? "Online" : "Offline" },
    { name: "Restaurant Name", data: restaurantDetails?.name },
    { name: "Secondary Contact No", data: restaurantDetails?.secondarycontactNo },
    { name: "Secondary Contact No Type", data: restaurantDetails?.secondarycontactNoType },
    { name: "Status", data: restaurantDetails?.status },
    {
      name: "Menu Image",
      data: restaurantDetails?.menuImage?.split(".")?.slice(- 1)?.includes("pdf") ?
        <Link to={`${S3_URL}/${restaurantDetails?.menuImage}`}  > <PdfSvgIcon width="100" height="100" /></Link>
        :
        <img
          src={restaurantDetails?.menuImage ? `${S3_URL}/${restaurantDetails?.menuImage}` : "https://www.team-bhp.com/sites/default/files/pictures2021/2.jpg"}
          alt={"img"}
          data-bs-toggle="modal"
          data-bs-target={`#imageViewModal`}
          style={{ cursor: 'pointer', maxWidth: '100%', maxHeight: '100px', borderRadius: "8%" }}
          onClick={() => { setSelectedImg(restaurantDetails?.menuImage ? `${S3_URL}/${restaurantDetails?.menuImage}` : "https://www.team-bhp.com/sites/default/files/pictures2021/2.jpg") }}
        />,
    },
    {
      name: "Menu Image For Online Orders",
      data: restaurantDetails?.menuImageForOnlineOrders?.split(".")?.slice(- 1)?.includes("pdf") ?
        <Link to={`${S3_URL}/${restaurantDetails?.menuImageForOnlineOrders}`}  > <PdfSvgIcon width="100" height="100" /></Link>
        :
        <img
          src={restaurantDetails?.menuImageForOnlineOrders ? `${S3_URL}/${restaurantDetails?.menuImageForOnlineOrders}` : "https://www.team-bhp.com/sites/default/files/pictures2021/2.jpg"}
          alt={"img"}
          data-bs-toggle="modal"
          data-bs-target={`#imageViewModal`}
          style={{ cursor: 'pointer', maxWidth: '100%', maxHeight: '100px', borderRadius: "8%" }}
          onClick={() => { setSelectedImg(restaurantDetails?.menuImageForOnlineOrders ? `${S3_URL}/${restaurantDetails?.menuImageForOnlineOrders}` : "https://www.team-bhp.com/sites/default/files/pictures2021/2.jpg") }}
        />,
    },
    {
      name: "Restaurant Image",
      data: restaurantDetails?.restaurantImage?.split(".")?.slice(- 1)?.includes("pdf") ?
        <Link to={`${S3_URL}/${restaurantDetails?.restaurantImage}`}  > <PdfSvgIcon width="100" height="100" /></Link>
        :
        <img
          src={restaurantDetails?.restaurantImage ? `${S3_URL}/${restaurantDetails?.restaurantImage}` : "https://www.team-bhp.com/sites/default/files/pictures2021/2.jpg"}
          alt={"img"}
          data-bs-toggle="modal"
          data-bs-target={`#imageViewModal`}
          style={{ cursor: 'pointer', maxWidth: '100%', maxHeight: '100px', borderRadius: "8%" }}
          onClick={() => { setSelectedImg(restaurantDetails?.restaurantImage ? `${S3_URL}/${restaurantDetails?.restaurantImage}` : "https://www.team-bhp.com/sites/default/files/pictures2021/2.jpg") }}
        />,
    },
  ]

  const rateSubmit = async (values) => {
    setRateLoader(true)
    try {
      const res = await editRestaurantApi(values)
      if (res.status === 200) {

        toast.success(res.data.message)
      }
    } catch (error) {
      toast.error("Failed to update rate")

    }

    setRateLoader(false)

    console.log(values)
  }

  const rateFormik = useFormik({
    initialValues: rateRestaurantInitialValues,
    validationSchema: rateRestaurantValidationSchema,
    onSubmit: rateSubmit
  })

  function handleInputChange(name, e, formik, input, type) {
    if (input == "input") {
      const { value } = e?.target
      if (type == "number" && isNaN(value)) return
      formik.setFieldValue(name, value)
    } else if (input == "date") {
      formik.setFieldValue(name, e)
    } else if (input == "select") {
      let list = [{ name, value: e }]
      if (name == "categoryId") {
        list.push({ name: "modelId", value: "" }, { name: "makeId", value: "" })
      } else if (name == "modelId") {
        list.push({ name: "makeId", value: "" })
      }

      list?.forEach(ele => {
        formik.setFieldValue(ele?.name, ele?.value)
      })
    } else if (input == "address") {
      formik.setFieldValue(name, e?.label)
    }

  }

  async function handleDriverDetailSubmit(payload, apiEndPoint) {
    try {
      console.log("in try block")
      setDetailsType({ ...detailsType, loading: true })
      const res = await apiEndPoint({ ...payload, partnerUserId: id })
      if (res?.status == 200 || res?.status == 201) {
        fetchDriverDetails();
        document.getElementById(detailsFields[activeTab]?.modalId)?.click()
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something Went Wrong")
    }
    setDetailsType({ ...detailsType, loading: false })
  }

  const detailsFields = {

          "restaurant": {
              format: [
                { name: "name", label: "Name", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                { name: "address", label: "Address", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                  { name: "openingTime", label: "Opening Time", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                  { name: "closingTime", label: "Closing Time", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                  { name: "totalEarnings", label: "Total Earnings", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                  { name: "days", label: "Days", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                  {
  name: "deliveryRestaurantTimingType",
  label: "Delivery Restaurant Timing Type",
  type: "select",
  handleOnChange: (selectedOption) => handleInputChange(selectedOption.value, "text"),
  options: [
    { label: "Delivery and restaurant timings are same", value: 0 },
    { label: "Delivery timing are different from restaurant timings", value: 1 }
  ]
}
,
                  { name: "establishmentType", label: "Establishment Type", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                  { name: "isOnline", label: "Online", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                  { name: "secondarycontactNo", label: "Secondary Contact No", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                  { name: "secondarycontactNoType", label: "Secondary Contact No Type", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                  {
  name: "status",
  label: "Status",
  type: "select",
  options: [
    { label: "Approved", value: "approved" },
    { label: "Rejected", value: "rejected" }
  ],
  handleOnChange: (option, ...rest) => handleInputChange(option?.value, ...rest, "text")
},

                  { name: "contactNo", label: "Contact No:", type: "input", handleOnChange: (...values) => handleInputChange(...values, "number") },
                  { name: "menuImage", label: "Menu Image", type: "file", acceptFiles: "image/*", loading: fileUpload?.includes("menuImage"), handleFileUpload },
                  { name: "menuImageForOnlineOrders", label: "Menu Image For Online Orders", type: "file", acceptFiles: "image/*", loading: fileUpload?.includes("menuImageForOnlineOrder"), handleFileUpload },
                  { name: "restaurantImage", label: "Restaurant Image", type: "file", acceptFiles: "image/*", loading: fileUpload?.includes("restaurantImage"), handleFileUpload },
                  // { name: "email", label: "Email", type: "input", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                  // { name: "NIN", label: "NIN", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },Menu Image For Online Orders
                  // { name: "permanentAddress", label: "Permanent address", type: "address", handleOnChange: (...values) => handleInputChange(...values, "text") },
                  // { name: "gender", label: "Gender", type: "select", options: genderOptions, handleOnChange: (...values) => handleInputChange(...values, "text") },
              ],
              initialvalue: restaurantInitialValue,
              validationSchema: restaurantValidationSchema,
              handleSubmit: (values) => {
                  console.log("Submitting values", values);
                  handleDriverDetailSubmit( values, updateRestaurantDetailsApi)},
              modalId: driverBankModal2
          },
    "bankDetails": {
      format: [
        { name: "bankName", label: "Bank Name", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
        { name: "accountNo", label: "Account No", type: "input", handleOnChange: (...values) => handleInputChange(...values, "number") },
        { name: "accountType", label: "Account Type", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
        { name: "Ifsc", label: "IFSC", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },

      ],
      initialvalue: bankDetailsInitialValue,
      validationSchema: bankDetailsValidationSchema,
      handleSubmit: (values) => handleDriverDetailSubmit(values, savePartnerBankDetailsApi),
      modalId: driverBankModal2
    },
    // "vehicle": {
    //     format: [
    //         { name: "categoryId", label: "Class", type: "select", options: vehicleCategoryList?.list?.filter((el, ind) => ind == vehicleCategoryList?.list.indexOf(vehicleCategoryList?.list?.filter((li, indx) => li?.id == el?.id)?.[0]))?.map(ele => { return { label: ele?.category, value: ele?.id } }), handleOnChange: (...values) => handleInputChange(...values, "text") },
    //         { name: "modelId", label: "Modal", type: "select", options: vehicleCategoryList?.list?.filter((el, ind) => ind == vehicleCategoryList?.list.indexOf(vehicleCategoryList?.list?.filter((li, indx) => li?.modelId == el?.modelId)?.[0]))?.map(ele => { return { label: ele?.model, value: ele?.modelId } }), handleOnChange: (...values) => handleInputChange(...values, "text") },
    //         { name: "makeId", label: "Type", type: "select", options: vehicleCategoryList?.list?.map(ele => { return { label: ele?.make, value: ele?.makeid } }), handleOnChange: (...values) => handleInputChange(...values, "text") },
    //         // { name: "makeId", label: "Type", type: "select", handleOnChange: (...values) => handleInputChange(...values, "select") },
    //         { name: "year", label: "Year", type: "input", handleOnChange: (...values) => handleInputChange(...values, "number") },
    //         { name: "color", label: "Color", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
    //         // { name: "licenseNo", label: "License number", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
    //         { name: "vehicleNumber", label: "Vehicle number", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
    //         // { name: "vehicleCertificate", label: "Vehicle certificate", type: "file", acceptFiles: "image/*", loading: fileUpload?.includes("vehicleCertificate"), handleFileUpload },
    //         // { name: "vehicleCertificateValidUpto", label: "Vehicle certificate valid upto", type: "date", handleOnChange: (...values) => handleInputChange(...values, "text") },
    //         // { name: "vehicleInsurance", label: "Vehicle insurance", type: "file", acceptFiles: "image/*", loading: fileUpload?.includes("vehicleInsurance"), handleFileUpload },
    //         // { name: "insuranceCertificateValidUpto", label: "Insurance certificate valid upto", type: "date", handleOnChange: (...values) => handleInputChange(...values, "text") },
    //     ],
    //     initialvalue: rentalVehicleInitialValue,
    //     validationSchema: rentalVehicleValidationSchema,
    //     handleSubmit: (values) => { 
    //         console.log("Submitting values", values);
    //         handleDriverDetailSubmit({ ...values, categoryId: values?.categoryId?.value, makeId: values?.makeId?.value, modelId: values?.modelId?.value }, createOrUpdateRentalVehicleDetailsApi)
    //     },
    //     modalId: driverBankModal2
    // },
    "driver": {
      format: [
        { name: "profileImage", label: "Profile image", type: "file", acceptFiles: "image/*", loading: fileUpload?.includes("profileImage"), handleFileUpload },
        { name: "name", label: "Name", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
        { name: "alternateMobile", label: "Alternate mobile", type: "input", handleOnChange: (...values) => handleInputChange(...values, "number") },
        { name: "email", label: "Email", type: "input", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
        { name: "NIN", label: "NIN", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
        { name: "permanentAddress", label: "Permanent address", type: "address", handleOnChange: (...values) => handleInputChange(...values, "text") },
        { name: "gender", label: "Gender", type: "select", options: genderOptions, handleOnChange: (...values) => handleInputChange(...values, "text") },
      ],
      initialvalue: profileDetailsInitialValue,
      validationSchema: profileValidationSchema,
      handleSubmit: (values) => {
        console.log("Submitting values", values);
        handleDriverDetailSubmit({ ...values, gender: values?.gender?.value },
          updatePartnerProfileApi)
      },
      modalId: driverBankModal2
    },

    "restaurant": {
      format: [
        { name: "name", label: "Name", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
        { name: "address", label: "Address", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
        { name: "openingTime", label: "Opening Time", type: "time", handleOnChange: (...values) => handleInputChange(...values, "text") },
        { name: "closingTime", label: "Closing Time", type: "time", handleOnChange: (...values) => handleInputChange(...values, "text") },
        { name: "totalEarnings", label: "Total Earnings", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
        { name: "days", label: "Days", type: "multi-select", options: daysOptions, handleOnChange: (...values) => handleInputChange(...values, "text") },
        { name: "deliveryRestaurantTimingType", label: "Delivery Restaurant Timing Type", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
        { name: "establishmentType", label: "Establishment Type", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
        { name: "isOnline", label: "Online", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
        { name: "secondarycontactNo", label: "Secondary Contact No", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
        { name: "secondarycontactNoType", label: "Secondary Contact No Type", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
        {
          name: "status", label: "Status", type: "select", options: [
            { label: "Approved", value: "approved" },
            { label: "Rejected", value: "rejected" }
          ], handleOnChange: (...values) => handleInputChange(...values, "select")
        },
        { name: "contactNo", label: "Contact No:", type: "input", handleOnChange: (...values) => handleInputChange(...values, "number") },
        { name: "menuImage", label: "Menu Image", type: "file", acceptFiles: "image/*", loading: fileUpload?.includes("menuImage"), handleFileUpload },
        { name: "menuImageForOnlineOrders", label: "Menu Image For Online Orders", type: "file", acceptFiles: "image/*", loading: fileUpload?.includes("menuImageForOnlineOrder"), handleFileUpload },
        { name: "restaurantImage", label: "Restaurant Image", type: "file", acceptFiles: "image/*", loading: fileUpload?.includes("restaurantImage"), handleFileUpload },
        // { name: "email", label: "Email", type: "input", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
        // { name: "NIN", label: "NIN", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },Menu Image For Online Orders
        // { name: "permanentAddress", label: "Permanent address", type: "address", handleOnChange: (...values) => handleInputChange(...values, "text") },
        // { name: "gender", label: "Gender", type: "select", options: genderOptions, handleOnChange: (...values) => handleInputChange(...values, "text") },
      ],
      initialvalue: restaurantInitialValue,
      validationSchema: restaurantValidationSchema,
      handleSubmit: (values) => {
        console.log("Submitting values", values);
        handleDriverDetailSubmit({ ...values, status: values?.status?.value, days: values?.days?.map(day => day.value) }, updateRestaurantDetailsApi)
      },
      modalId: driverBankModal2
    },

    "document": {
      format: [
        // { name: "type", label: "Type", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
        // { name: "panNumber", label: "Number", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
        //   { name: "validUpto", label: "Valid Upto", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
        //   { name: "panApprovalStatus", label: "Status", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
        //   { name: "panImage", label: "File", type: "file", acceptFiles: "image/*", loading: fileUpload?.includes("File"), handleFileUpload },
        // { name: "email", label: "Email", type: "input", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
        // { name: "NIN", label: "NIN", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },Menu Image For Online Orders
        // { name: "permanentAddress", label: "Permanent address", type: "address", handleOnChange: (...values) => handleInputChange(...values, "text") },
        // { name: "gender", label: "Gender", type: "select", options: genderOptions, handleOnChange: (...values) => handleInputChange(...values, "text") },
        ...(selectedDocument.type == "Pan card" ?
          [
            // { name: "type", label: "Type", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
            { name: "panNumber", label: "Number", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
            // { name: "validUpto", label: "Valid Upto", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
            // { name: "panApprovalStatus", label: "Status", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
            { name: "panImage", label: "File", type: "file", acceptFiles: "image/*", loading: fileUpload?.includes("File"), handleFileUpload },
          ] :
          (selectedDocument.type == "GST" ?
            [
              // { name: "type", label: "Type", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
              { name: "gstNumber", label: "Number", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
              // { name: "validUpto", label: "Valid Upto", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
              // { name: "gstApprovalStatus", label: "Status", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
              { name: "gstCertificate", label: "File", type: "file", acceptFiles: "image/*", loading: fileUpload?.includes("File"), handleFileUpload },
            ] : (selectedDocument.type == "FSSAI Certificate" ?
              [
                // { name: "type", label: "Type", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                { name: "FSSAICertificateNo", label: "Number", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                { name: "FSSAIExpiredDate", label: "Valid Upto", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                // { name: "fssaiApprovalStatus", label: "Status", type: "input", handleOnChange: (...values) => handleInputChange(...values, "text") },
                { name: "FSSAICertificate", label: "File", type: "file", acceptFiles: "image/*", loading: fileUpload?.includes("File"), handleFileUpload },
              ] : []))

        ),
      ],
      initialvalue: documentInitialValues,
      validationSchema: documentValidationSchemas[selectedDocument.type],
      handleSubmit: (values) => {
        console.log("Submitting values", values);
        handleDriverDetailSubmit({ ...values, gender: values?.gender?.value },
          updateRestaurantDocApi)
      },
      modalId: driverBankModal2
    },

  }


  const restaurantDetailsFormik = useFormik({
    initialValues: detailsFields?.[activeTab]?.initialvalue,
    validationSchema: detailsFields?.[activeTab]?.validationSchema,
    enableReinitialize: true,
    onSubmit: detailsFields?.[activeTab]?.handleSubmit
  })

  console.log("erooooorrrr", restaurantDetailsFormik.errors)

  const tabData = [
    {
      name: "Profile Details", tab: "driver", setTab: toggleTab, data: <div className="row card">
        <div className="row mt-3">
          <div className='d-flex justify-content-end'>
            <button className='btn btn-primary' onClick={() => restaurantDetailsFormik.setValues({ ...profileDetails, gender: { label: capitalizeWords(profileDetails?.gender), value: profileDetails?.gender } })} data-bs-toggle="modal" data-bs-target={`#driverBankModal2`}>Edit</button>
          </div>
          <div className="user-details">
            <table className="table table-md table-hover card-table">
              <tbody>
                {
                  profileData.map((ele, index) => (
                    <tr key={index}>
                      <td>{ele.name}:</td>
                      <td>{ele.data}</td>
                    </tr>
                  ))
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    },
    {
      name: "Restaurant Details", tab: "restaurant", setTab: toggleTab, data: <div className="row card">
        <div className="row mt-3">
          <div className='d-flex justify-content-end'>
            <button
              className='btn btn-primary'
              onClick={() => restaurantDetailsFormik.setValues({
                ...restaurantDetails,
                status: {
                  label: restaurantDetails?.status,
                  value: restaurantDetails?.status
                },
                days: restaurantDetails?.days?.map(day => ({
                  label: day,
                  value: day
                })) || [],
              })}
              data-bs-toggle="modal"
              data-bs-target={`#driverBankModal2`}
            >
              Edit
            </button>
          </div>
          <div className="user-details">
            <table className="table table-md table-hover card-table">
              <tbody>
                {/* {
                                    profileData.map((ele, index) => (
                                        <tr key={index}>
                                            <td>{ele.name}:</td>
                                            <td>{ele.data}</td>
                                        </tr>
                                    ))
                                } */}
                {
                  restaurant?.map((ele, index) => (
                    <tr key={index}>
                      <td>{ele.name}:</td>
                      <td>{ele.data}</td>
                    </tr>
                  ))
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    },
    { name: "Bank Details", tab: "bankDetails", setTab: toggleTab, data: <div className='p-3 card'><CommonTable headers={bankDetailsHeaderData} data={bankDetailsTableData} /></div> },
    {
      name: "Documents", tab: "document", setTab: toggleTab, data: <div className="row card ">
        <div className="mt-3 table-responsive  " style={{ overflowX: "inherit" }}>
          <table className="table table-md table-hover card-table">
            <thead>
              <tr>
                <th> <span className="list-sort text-muted">Type</span></th>
                <th> <span className="list-sort text-muted">Number</span></th>
                <th className='text-center'> <span className="list-sort text-muted">File</span></th>
                <th className='text-center'> <span className="list-sort text-muted">Valid Upto</span></th>
                <th className='text-center'> <span className="list-sort text-muted">Status</span></th>
                <th className='text-center'> <span className="list-sort text-muted">Action</span></th>
              </tr>
            </thead>
            <tbody>
              {console.log("final rest", restaurantDocument)}
              <DocumentDisplay
                title="Pan card"
                document={restaurantDocument?.panImage}
                setSelectedImg={setSelectedImg}
                status={restaurantDocument?.panApprovalStatus}
                keyName={"panApprovalStatus"}
                number={restaurantDocument?.panNumber}
                restaurantId={restaurantDocument?.restaurantId}
              />

              {restaurantDocument?.gstCertificate && (
                <DocumentDisplay
                  title="GST"
                  document={restaurantDocument?.gstCertificate}
                  setSelectedImg={setSelectedImg}
                  status={restaurantDocument?.gstApprovalStatus}
                  keyName={"gstApprovalStatus"}
                  number={restaurantDocument?.gstNumber}
                  restaurantId={restaurantDocument?.restaurantId}

                />
              )}
              <DocumentDisplay
                title="FSSAI Certificate"
                document={restaurantDocument?.FSSAICertificate}
                setSelectedImg={setSelectedImg}
                status={restaurantDocument?.fssaiApprovalStatus}
                keyName={"fssaiApprovalStatus"}
                validUpto={restaurantDocument?.FSSAIExpiredDate}
                number={restaurantDocument?.FSSAICertificateNo}
                restaurantId={restaurantDocument?.restaurantId}

              />
            </tbody>
          </table>
        </div>
      </div>
    },
    adminDetail?.role === "superAdmin" && {
      name: "Rate", tab: "rate", setTab: toggleTab, data:
        <div className="card">
          <div className="card-header" style={{ backgroundColor: "var(--color-card-bg)" }}>
            Rate
          </div>
          <div className="card-body" >
            <div className='p-5'>
              <form onSubmit={rateFormik.handleSubmit}>
                <div className="form-group row row-cols-4">

                  {/* <div className='d-flex gap-3'>
                    <label htmlFor='deliveryFee' className=" col-form-label">Delivery fee</label>
                    <div className="">
                      <input type="text" className="form-control" id='deliveryFee' name='deliveryFee' placeholder="0" onChange={rateFormik.handleChange} onBlur={rateFormik.handleBlur} value={rateFormik.values.deliveryFee} />
                      {rateFormik.touched?.deliveryFee && rateFormik.errors?.deliveryFee ? (<div className='req-error'>{rateFormik?.errors?.deliveryFee}</div>) : null}
                    </div>
                  </div> */}

                  <div className='d-flex gap-3'>
                    <label htmlFor='tax' className=" col-form-label">Commission(%)</label>
                    <div className="">
                      <input type="text" className="form-control" id='tax' placeholder="0" name='tax' onChange={rateFormik.handleChange} onBlur={rateFormik.handleBlur} value={rateFormik.values.tax} />
                      {rateFormik.touched?.tax && rateFormik.errors?.tax ? (<div className='req-error'>{rateFormik?.errors?.tax}</div>) : null}
                    </div>
                  </div>

                  <div className='d-flex gap-3'>
                    <label htmlFor='discount' className=" col-form-label">Discount(%)</label>
                    <div className="">
                      <input type="text" className="form-control" id='discount' placeholder="0" name='discount' onChange={rateFormik.handleChange} onBlur={rateFormik.handleBlur} value={rateFormik.values.discount} />
                      {rateFormik.touched?.discount && rateFormik.errors?.discount ? (<div className='req-error'>{rateFormik?.errors?.discount}</div>) : null}
                    </div>
                  </div>

                  <div className='d-flex align-items-center gap-3'>
                    <label htmlFor='descountOnOff' className=" col-form-label">Discount(on/off)</label>
                    <div className="form-check form-switch">
                      <input className="form-check-input" type="checkbox" role="switch" checked={rateFormik?.values?.discountOnOff} id="discountOnOff" onChange={() => rateFormik?.setFieldValue("discountOnOff", !Boolean(rateFormik?.values?.discountOnOff))} />
                      {rateFormik.touched?.discountOnOff && rateFormik.errors?.discountOnOff ? (<div className='req-error'>{rateFormik?.errors?.discountOnOff}</div>) : null}
                    </div>
                  </div>
                  <div className="d-flex align-items-end"  >
                    <button type="submit" className="btn btn-sm btn-primary" disabled={rateLoader}>Submit</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
    },
    {
      name: "Menu & item", tab: "menuItem", setTab: toggleTab, data: <RestaurantMenu id={params?.id} />
    },
    { name: "Review", tab: "review", setTab: toggleTab, data: <div className="card row" ><PartnerReviewTable id={params?.id} /></div> },
  ]

  return (
    <div className="main-content">
      <div className="container-fluid">

        {loader ? (
          <div className="text-center">
            <Spinwheel />
          </div>
        ) : (
          <>
            <div className="row align-items-end">
              <div className="col-auto">
                <div className="avatar avatar-xxl header-avatar-top mt-3">
                  <img src={profileDetails?.profileImage ? `${S3_URL}/${profileDetails?.profileImage}` : "https://img.freepik.com/premium-vector/man-avatar-profile-picture-vector-illustration_268834-538.jpg"} alt="profile" className="avatar-img rounded-circle border border-4 border-body" />
                </div>
              </div>
              <div className="col mb-3 ms-n3 ms-md-n2">
                <h1 className="header-title">
                  {capitalizeWords(profileDetails.name)}
                </h1>
              </div>
              <div className="col-12 col-md-auto mt-2 mt-md-0 mb-md-3">
                {(profileDetails.vendorStatus === "pending") ? <><button type="button" className="btn btn-outline-primary me-2" data-bs-toggle="modal"
                  data-bs-target={`#confirmationModal`}
                  onClick={(e) => { setConfirmStatus(prevState => ({ ...prevState, status: "approved", userId: id })) }}>Approve</button>
                  <button type="button" className="btn btn-outline-secondary" data-bs-toggle="modal"
                    data-bs-target={`#confirmationModal`}
                    onClick={(e) => { setConfirmStatus(prevState => ({ ...prevState, status: "rejected", userId: id })) }}>Reject</button></> :
                  <div className={`badge fs-4  ${profileDetails.vendorStatus === "approved" ? "bg-primary-soft" : "bg-secondary-soft"}`}>{capitalizeWords(profileDetails.vendorStatus)}</div>
                }
              </div>
            </div>

            <div className='d-flex justify-content-between'>
              <ul className="nav nav-tabs">
                {
                  tabData.map((ele, index) => (
                    <li className="nav-item">
                      <button
                        className={`nav-link ${activeTab === ele.tab ? 'active' : ''}`}
                        onClick={() => ele.setTab(ele.tab)}
                      >
                        {ele.name}
                      </button>
                    </li>
                  ))
                }
              </ul>
              <div>
              </div>
            </div>

            {
              tabData.map((ele) => (
                activeTab === ele.tab ? ele.data : null
              ))
            }
          </>
        )}

        {<ConfirmationModal
          handleConfirm={handleChangeStatus}
          confirmStatus={confirmStatus}
        />}
        <ImageViewModal imgUrl={selectedImg} modalId={"imageViewModal"} />
        <button id="confirmationModal2Btn" className='d-none' data-bs-toggle="modal" data-bs-target={`#${confirmationModalId2}`}></button>
        <ConfirmationModal modalId={confirmationModalId2} message={<> Do you want to continue?</>} handleConfirm={() => handleChangeDocumentStatus()} title={"Warning!"} confirmStatus={""} />
        <AddOrUpdateDetails formik={restaurantDetailsFormik} dataFormat={detailsFields[activeTab]?.format} detailsFor={detailsType?.type} addLoader={detailsType?.loading} modalId={driverBankModal2} />
      </div>
    </div>

  );
};

export default RestaurentDetails;
